const CustomerType = Object.freeze({
    INDIVIDUAL: 1,
    COMPANY: 2,
});

export default CustomerType;
